<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="剧本名称" prop="scriptName">
                <a-input v-model="queryParam.scriptName" placeholder="请输入剧本名称" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="是否手动调价" prop="isManualPrice">
                  <a-select placeholder="请选择是否手动调价" style="width:100%" v-model="queryParam.isManualPrice" allowClear>
                    <a-select-option value="true">是</a-select-option>
                    <a-select-option value="false">否</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="省" prop="areap">
                  <a-input v-model="queryParam.areap" placeholder="请输入省" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="市" prop="areac">
                  <a-input v-model="queryParam.areac" placeholder="请输入市" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="区(县)" prop="areax">
                  <a-input v-model="queryParam.areax" placeholder="请输入区(县)" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="剧本价格" prop="prices">
                  <a-input-number v-model="queryParam.prices" :min="0" :step="1" :precision="0" placeholder="请输入剧本价格" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="再领一本价格" prop="orderPrices">
                  <a-input-number v-model="queryParam.orderPrices" :min="0" :step="1" :precision="0" placeholder="请输入剧本再领一本价格" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="预购X车价格" prop="preOrderPrices">
                  <a-input-number v-model="queryParam.preOrderPrices" :min="0" :step="1" :precision="0" placeholder="请输入剧本预购X车价格" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="城市线级" prop="tierCities">
                  <a-select style="width: 100%" v-model="queryParam.tierCities" placeholder="请选择城市线级" allow-clear>
                    <a-select-option :value="1">一线</a-select-option>
                    <a-select-option :value="1.5">新一线</a-select-option>
                    <a-select-option :value="2">二线</a-select-option>
                    <a-select-option :value="3">三线</a-select-option>
                    <a-select-option :value="4">四线</a-select-option>
                    <a-select-option :value="5">五线</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="openEditPricesModal" v-hasPermi="['played:shop:edit']">
          <a-icon type="edit" />修改剧本价格
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="editIsManualPrice" v-hasPermi="['played:shop:edit']">
          <a-icon type="edit" />恢复自动调价
        </a-button>
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['played:shop:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['played:shop:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:shop:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['played:shop:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['played:shop:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['played:shop:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['played:shop:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

      <a-modal
        v-model="editPricesVisible"
        title="修改剧本价格"
        :closable="true"
      >
        <a-form-model ref="editPricesForm" :model="editPricesForm" :rules="editPricesRules">
          <a-form-model-item label="价格类型" prop="pricesType" >
            <a-select style="width: 100%" v-model="editPricesForm.pricesType" placeholder="请选择价格类型" allow-clear>
              <a-select-option :value="0">剧本价格</a-select-option>
              <a-select-option :value="1">再领X本价格</a-select-option>
              <a-select-option :value="2">预购X车价格</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="价格" prop="editPrices" >
            <a-input-number v-model="editPricesForm.editPrices" :min="0" :step="1" :precision="0" placeholder="请输入价格" />
          </a-form-model-item>
        </a-form-model>
        <template slot="footer">
          <a-button type="primary" :loading="editPricesLoading" @click="editPricesSubmit()">
            修改
          </a-button>
          <a-button @click="editPricesVisible = false">取消</a-button>
        </template>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageShopScriptV2, delShopScript, editPrices, editIsManualPrice } from '@/api/played/shopScript'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ShopScript',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      editPricesVisible: false,
      editPricesLoading: false,
      editPricesForm: {
        pricesType: undefined,
        editPrices: undefined,
        ids: undefined,
        prices: undefined,
        orderPrices: undefined,
        preOrderPrices: undefined
      },
      editPricesRules: {
        editPrices: [
          { required: true, message: '请输入价格', trigger: ['blur', 'change'] }
        ],
        pricesType: [
          { required: true, message: '请选择价格类型', trigger: ['blur', 'change'] }
        ]
      },
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: null,
        shopName: null,
        scriptName: null,
        tierCities: undefined,
        shopId: null,
        scriptId: null,
        isReserve: null,
        sort: null,
        prices: null,
        orderPrices: null,
        preOrderPrices: null,
        volumePackageDiscount: null,
        couponPackPromoValidity: null,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        isManualPrice: undefined,
        createTime: null,
        updateTime: null,
        creator: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剧本价格',
          dataIndex: 'prices',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '再领X本价格',
          dataIndex: 'orderPrices',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '预购X车价格',
          dataIndex: 'preOrderPrices',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '卷包折扣',
          dataIndex: 'volumePackageDiscount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '卷包优惠卷有效期(单位:天)',
          dataIndex: 'couponPackPromoValidity',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '省',
          dataIndex: 'areap',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '市',
          dataIndex: 'areac',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '区(县)',
          dataIndex: 'areax',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '城市线级',
          dataIndex: 'tierCities',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 1) {
              return '一线'
            }
            if (text === 1.5) {
              return '新一线'
            }
            if (text === 2) {
              return '二线'
            }
            if (text === 3) {
              return '三线'
            }
            if (text === 4) {
              return '四线'
            }
            if (text === 5) {
              return '五线'
            }
            return text
          }
        },
        {
          title: '是否手动调价',
          dataIndex: 'isManualPrice',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text) {
              return '是'
            }
            if (!text) {
              return '否'
            }
            return text
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '10%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询银河打本店铺剧本列表 */
    getList () {
      this.loading = true
      pageShopScriptV2(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        id: null,
        shopName: null,
        scriptName: null,
        tierCities: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        shopId: null,
        scriptId: null,
        isReserve: null,
        sort: null,
        prices: null,
        orderPrices: null,
        preOrderPrices: null,
        volumePackageDiscount: null,
        couponPackPromoValidity: null,
        isManualPrice: undefined,
        createTime: null,
        updateTime: null,
        creator: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delShopScript(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    openEditPricesModal() {
      this.editPricesVisible = true
      this.editPricesForm = {
        pricesType: undefined,
        editPrices: undefined,
        ids: undefined,
        prices: undefined,
        orderPrices: undefined,
        preOrderPrices: undefined
      }
    },
    editIsManualPrice() {
      var that = this
      this.$confirm({
        title: '确认恢复所选中数据?',
        content: '当前选中编号为' + that.ids + '的数据',
        onOk () {
          return editIsManualPrice({ 'ids': that.ids }).then(response => {
            that.$message.success(
              '恢复成功',
              3
            )
            that.getList()
          })
        },
        onCancel () {}
      })
    },
    editPricesSubmit() {
      this.$refs.editPricesForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.editPricesLoading = true
        this.editPricesForm.ids = this.ids
        if (this.editPricesForm.pricesType === 0) {
          this.editPricesForm.prices = this.editPricesForm.editPrices
        } else if (this.editPricesForm.pricesType === 1) {
          this.editPricesForm.orderPrices = this.editPricesForm.editPrices
        } else if (this.editPricesForm.pricesType === 2) {
          this.editPricesForm.preOrderPrices = this.editPricesForm.editPrices
        }
        editPrices(this.editPricesForm).then(response => {
          this.$message.success(
            '修改成功',
            3
          )
          this.getList()
          this.editPricesVisible = false
        }).finally(() => {
          this.editPricesLoading = false
        })
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/shop/export', {
            ...that.queryParam
          }, `shop_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
